import { useEffect } from 'react';

/**
 * Function to be run only once after mounting. Takes empty array of values
 * https://medium.com/@faboulaws/3-custom-react-effect-hooks-for-your-toolbox-96d659d2ca9d
 *
 * @param effectFn Function to be run on mount
 */
export default (effectFn) => useEffect(effectFn, []);
